module.exports = __webpack_public_path__ + "static/media/profile.c68650e9.jpg";